import { RecordType } from '@petconsole/pure-base';
import { sitterApiEntity } from '@petconsole/pure-fe-api';
import { SitterRecord } from '@petconsole/pure-shared';
import { sliceHookTypes } from '../../../helpers';
import {
  BaseSliceOptions,
  BaseSliceTab,
  CitySearchHooks,
  OurEntityHooks,
  RatingHooks,
  RequiredCrudSliverHooks,
  RequiredSliverHooks,
  TabValueHooks,
} from '../../../types';
import BaseEntitySlice from '../../base/BaseEntitySlice';

type ApiEntityRecord = SitterRecord;

const apiEntity = sitterApiEntity;
const { name: sliceName, plural } = apiEntity;
const sitter = sliceName;
const sitters = plural;
const sitterAdmin = `${sliceName}Admin`;

const Tab = { sitterAdmin, sitter, sitters } as const;
type Tabs = { [key in keyof typeof Tab]: BaseSliceTab };
type TabHooks = { [key in keyof typeof Tab]: TabValueHooks };
const tabs: Tabs = {
  sitterAdmin: { default: '' },
  sitter: { default: '' },
  sitters: { default: '' },
};

const options: BaseSliceOptions<ApiEntityRecord> = {
  ...apiEntity,
  sortProperty: 'sitterName',
  hasCitySliver: true,
  hasNewestSliver: true,
  hasCitySearch: true,
  hasDefaultProperties: true,
  hasRating: true,
  tabs,
};
const { hooks, reducer } = new BaseEntitySlice<ApiEntityRecord>({ options });
const { crudHooks, sliverHooks, propertyHooks, citySearchHooks, ratingHooks, tabHooks } = sliceHookTypes;

export interface OurSitterHooks<T extends RecordType = ApiEntityRecord> extends OurEntityHooks<T> {
  sitterHooks: RequiredCrudSliverHooks;
  citySitterHooks: RequiredSliverHooks;
  newestSitterHooks: RequiredSliverHooks;
  propertyHooks: RecordType;
  citySearchHooks: CitySearchHooks;
  ratingHooks: RatingHooks;
  tabHooks: TabHooks;
}

export const ourSitterHooks: OurSitterHooks = {
  entity: apiEntity,
  sitterHooks: crudHooks(apiEntity, hooks) as RequiredCrudSliverHooks,
  citySitterHooks: sliverHooks(apiEntity, 'City', hooks) as RequiredSliverHooks,
  newestSitterHooks: sliverHooks(apiEntity, 'Newest', hooks) as RequiredSliverHooks,
  citySearchHooks: citySearchHooks(apiEntity, hooks),
  propertyHooks: propertyHooks(apiEntity, hooks),
  ratingHooks: ratingHooks(apiEntity, hooks),
  tabHooks: <TabHooks>tabHooks(Object.keys(Tab), hooks),
};

export default reducer;
